import React, { useState } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';

interface MenuItemProps {
  label: string;
  icon: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
  collapsed: boolean;
  subItems?: Array<{
    id: string;
    label: string;
    path: string;
  }>;
  onSubItemClick?: (id: string, path: string) => void;
  activeSubItem?: string;
}

const MenuItem: React.FC<MenuItemProps> = ({ 
  label, 
  icon, 
  isActive, 
  onClick, 
  collapsed, 
  subItems, 
  onSubItemClick,
  activeSubItem
}) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(isActive);
  
  const hasSubItems = subItems && subItems.length > 0;
  
  const toggleSubMenu = (e: React.MouseEvent) => {
    if (hasSubItems) {
      e.stopPropagation();
      setIsSubMenuOpen(!isSubMenuOpen);
      onClick(); // Vẫn gọi onClick để đánh dấu menu cha là active
    }
  };
  
  const handleSubItemClick = (id: string, path: string, e: React.MouseEvent) => {
    e.stopPropagation();
    if (onSubItemClick) {
      onSubItemClick(id, path);
    }
  };
  
  return (
    <>
      <li 
        className={`sidebar-menu-item ${isActive ? 'active' : ''} ${hasSubItems ? 'has-submenu' : ''}`} 
        onClick={hasSubItems ? toggleSubMenu : onClick}
      >
        <div className="sidebar-menu-icon">
          {icon}
        </div>
        {!collapsed && (
          <div className="sidebar-menu-content">
            <span className="sidebar-menu-label">{label}</span>
            {hasSubItems && (
              <span className="submenu-arrow">
                {isSubMenuOpen ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
              </span>
            )}
          </div>
        )}
        {collapsed && (
          <div className="sidebar-tooltip">
            {label}
            {hasSubItems && <span className="tooltip-arrow">►</span>}
          </div>
        )}
      </li>
      
      {/* Sub menu items */}
      {hasSubItems && isSubMenuOpen && !collapsed && (
        <ul className="sidebar-submenu">
          {subItems.map(item => (
            <li 
              key={item.id}
              className={`sidebar-submenu-item ${activeSubItem === item.id ? 'active' : ''}`}
              onClick={(e) => handleSubItemClick(item.id, item.path, e)}
            >
              <span className="submenu-dot">•</span>
              <span className="submenu-label">{item.label}</span>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default MenuItem; 